export const foilVertex = `
varying vec2 vUv;
void main() {
  vUv = uv;
  gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
}
`;

export const foilFragment = `
uniform sampler2D uArt;
uniform float uTime;
uniform float uHover;
uniform float uSelected;
uniform float uDim;
uniform float uFoil;
varying vec2 vUv;

void main() {
  vec4 art = texture2D(uArt, vUv);
  float foil = sin((vUv.x + vUv.y + uTime * 0.5) * 20.0) * 0.5 + 0.5;
  vec3 holo = mix(vec3(0.9, 0.75, 0.4), vec3(0.4, 0.7, 1.0), foil);
  // edges catch more light; foil cards shimmer across the whole face
  float edge = smoothstep(0.38, 0.5, max(abs(vUv.x - 0.5), abs(vUv.y - 0.5)));
  float sweep = smoothstep(0.08, 0.0, abs(fract(vUv.x * 0.6 + vUv.y * 0.4 - uTime * 0.12) - 0.5));
  float shine = foil * (0.04 + edge * 0.25 + uFoil * 0.22) * (1.0 + uHover * 1.2 + uSelected * 0.8) + sweep * (0.05 + uHover * 0.12);
  vec3 col = art.rgb * uDim + holo * shine;
  col += vec3(0.85, 0.65, 0.2) * uSelected * edge * 0.6;
  gl_FragColor = vec4(col, art.a);
}
`;
